import { SideMenu } from '@xprog/prensa'
import React from 'react'

import { SideMenuSectionHeader } from './SectionHeader/SideMenuSectionHeader'
import { SideMenuSectionContent } from './SectionContent/SideMenuSectionContent'
import { SideMenuSectionFooter } from './SectionFooter/SideMenuSectionFooter'
import { SideMenuLeftProps } from './props'

export const SideMenuLeft: React.FC<SideMenuLeftProps> = ({
  assets,
  close,
  open,
  navItems,
  onLogin,
  onLogout,
  variant
}) => {
  return (
    <SideMenu
      open={open}
      close={close}
      sections={{
        header: (
          <SideMenuSectionHeader
            config={assets.menus.sideMenuLeft.sectionHeader}
            onClose={close}
            onLogin={onLogin}
            onLogout={onLogout}
            variant={variant}
          />
        ),
        content: (
          <SideMenuSectionContent
            config={assets.menus.sideMenuLeft.sectionContent}
            navItems={navItems}
          />
        ),
        footer: (
          <SideMenuSectionFooter
            config={assets.menus.sideMenuLeft.sectionFooter}
          />
        )
      }}
      css={{
        header: {
          width: '100%'
        },
        content: {
          align: ['column', 'center', 'top'],
          width: '100%'
        },
        footer: {
          alignSelf: 'baseline',
          width: '100%'
        },
        drawer: {
          content: {
            align: ['column', 'center', 'between'],
            height: '100vh',
            width: '320px',
            zIndex: 9999
          },
          spacer: {
            align: ['column', 'center', 'top'],
            height: '100vh',
            width: '100%'
          }
        }
      }}
    />
  )
}
